/**
 * Get current date/time in Mountain Time (America/Denver)
 */
export function getMountainNow() {
  return new Date(new Date().toLocaleString("en-US", { timeZone: "America/Denver" }));
}

/**
 * Get today's date string (YYYY-MM-DD) in Mountain Time
 */
export function getMountainToday() {
  const now = new Date();
  return now.toLocaleDateString("en-CA", { timeZone: "America/Denver" });
}

/**
 * Format a date to Mountain Time display string
 * @param {Date|string} date 
 * @param {object} options - Intl.DateTimeFormat options
 */
export function formatMountain(date, options = {}) {
  const d = typeof date === "string" ? new Date(date) : date;
  return d.toLocaleString("en-US", { timeZone: "America/Denver", ...options });
}
